import React from 'react'
import UpdatedMainLayout from 'src/layouts/UpdatedMainLayout/UpdatedMainLayout'


const WebstudioPage = ({ user }) => {
  return (
    <UpdatedMainLayout user={user}>
      <iframe
        src="https://p-1f30086f-88d7-48a6-bc04-386f779a16c8.apps.webstudio.is/?authToken=d425368a-c588-4d51-ad69-ddb671b6995c&mode=design"
        title="Webstudio"
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
        }}
      ></iframe>
    </UpdatedMainLayout>
  )
}

export default WebstudioPage;
